// TODO(CP-7859) Add "COURSE" and "NONE" to this enum once added to the CEDAR
//  schema defined
export enum RegionOverrideSource {
    DISTRICT = "DISTRICT",
    IP_GEOLOCATION = "IP_GEOLOCATION",
    SCHOOL = "SCHOOL",
    USER_SETTING = "USER_SETTING",
}

export type RegionOverrideResult =
    | {
          status: "no-data";
      }
    | {
          status: "aborted";
      }
    | {
          status: "loading";
      }
    | {
          status: "error";
          error: Error;
      }
    | {
          status: "success";
          regionCode: string;
          regionSource: RegionOverrideSource;
      };
